var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{staticClass:"icon rounded",class:[
    `icon_color_${_vm.icon.color}`,
    `icon_size_${_vm.size}`
  ]},[_vm._v(" "+_vm._s(_vm.icon.mdi)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }